import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppConfigService } from "@master/core/dist/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class PluginService extends BaseService {
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService);
  }

  map(dataTransport): Promise<any> {
    return this.http
      .post(`${this.getUrl()}/previsions/map`, dataTransport, {
        headers: new HttpHeaders().set("Content-Type", "application/json"),
      })
      .toPromise();
  }
}
